import React, { useState } from "react";

const ContentTab = ({ handleLayoutChange, selectedLayout,updateBusinessHoursTabData,businessHoursTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    //Sunday
    const [showSunday, setShowSunday] = useState(Number(businessHoursTabData.is_sunday_on));
    const [sundayStartTime, setSundayStartTime] = useState(businessHoursTabData.sunday_start_time);
    const [sundayStartTimeDropdownOpen, setSundayStartTimeDropdownOpen] = useState(false);
    const [sundayEndTime, setSundayEndTime] = useState(businessHoursTabData.sunday_end_time);
    const [sundayEndTimeDropdownOpen, setSundayEndTimeDropdownOpen] = useState(false);

    //Monday
    const [showMonday, setShowMonday] = useState(Number(businessHoursTabData.is_monday_on));
    const [mondayStartTime, setMondayStartTime] = useState(businessHoursTabData.monday_start_time);
    const [mondayStartTimeDropdownOpen, setMondayStartTimeDropdownOpen] = useState(false);
    const [mondayEndTime, setMondayEndTime] = useState(businessHoursTabData.monday_end_time);
    const [mondayEndTimeDropdownOpen, setMondayEndTimeDropdownOpen] = useState(false);

    //Tuesday
    const [showTuesday, setShowTuesday] = useState(Number(businessHoursTabData.is_tuesday_on));
    const [tuesdayStartTime, setTuesdayStartTime] = useState(businessHoursTabData.tuesday_start_time);
    const [tuesdayStartTimeDropdownOpen, setTuesdayStartTimeDropdownOpen] = useState(false);
    const [tuesdayEndTime, setTuesdayEndTime] = useState(businessHoursTabData.tuesday_end_time);
    const [tuesdayEndTimeDropdownOpen, setTuesdayEndTimeDropdownOpen] = useState(false);
    
    //Wednesday
    const [showWednesday, setShowWednesday] = useState(Number(businessHoursTabData.is_wednesday_on));
    const [wednesdayStartTime, setWednesdayStartTime] = useState(businessHoursTabData.wednesday_start_time);
    const [wednesdayStartTimeDropdownOpen, setWednesdayStartTimeDropdownOpen] = useState(false);
    const [wednesdayEndTime, setWednesdayEndTime] = useState(businessHoursTabData.wednesday_end_time);
    const [wednesdayEndTimeDropdownOpen, setWednesdayEndTimeDropdownOpen] = useState(false);

    //Thursday
    const [showThursday, setShowThursday] = useState(Number(businessHoursTabData.is_thursday_on));
    const [thursdayStartTime, setThursdayStartTime] = useState(businessHoursTabData.thursday_start_time);
    const [thursdayStartTimeDropdownOpen, setThursdayStartTimeDropdownOpen] = useState(false);
    const [thursdayEndTime, setThursdayEndTime] = useState(businessHoursTabData.thursday_end_time);
    const [thursdayEndTimeDropdownOpen, setThursdayEndTimeDropdownOpen] = useState(false);

    //Friday
    const [showFriday, setShowFriday] = useState(Number(businessHoursTabData.is_friday_on));
    const [fridayStartTime, setFridayStartTime] = useState(businessHoursTabData.friday_start_time);
    const [fridayStartTimeDropdownOpen, setFridayStartTimeDropdownOpen] = useState(false);
    const [fridayEndTime, setFridayEndTime] = useState(businessHoursTabData.friday_end_time);
    const [fridayEndTimeDropdownOpen, setFridayEndTimeDropdownOpen] = useState(false);

    //Saturday
    const [showSaturday, setShowSaturday] = useState(Number(businessHoursTabData.is_saturday_on));
    const [saturdayStartTime, setSaturdayStartTime] = useState(businessHoursTabData.saturday_start_time);
    const [saturdayStartTimeDropdownOpen, setSaturdayStartTimeDropdownOpen] = useState(false);
    const [saturdayEndTime, setSaturdayEndTime] = useState(businessHoursTabData.saturday_end_time);
    const [saturdayEndTimeDropdownOpen, setSaturdayEndTimeDropdownOpen] = useState(false);
    //Other detail
    const [businessName, setBusinessName] = useState(businessHoursTabData.business_name);
    const [aboutCompany, setAboutCompany] = useState(businessHoursTabData.about_company);
    const [phoneNumber, setPhoneNumber] = useState(businessHoursTabData.phone_number);
    const [email, setEmail] = useState(businessHoursTabData.email);
    const [website, setWebsite] = useState(businessHoursTabData.website);
    const [address, setAddress] = useState(businessHoursTabData.address);
    const [showLabels, setShowLabels] = useState(Number(businessHoursTabData.is_show_labels_on));
    const [showIcons, setShowIcons] = useState(Number(businessHoursTabData.is_show_icons_on));

    //Time List
    const timeLists = ["12:00 AM","1:00 AM","2:00 AM","3:00 AM","4:00 AM","5:00 AM","6:00 AM","7:00 AM","8:00 AM","9:00 AM","10:00 AM","11:00 AM","12:00 PM","1:00 PM","2:00 PM","3:00 PM","4:00 PM","5:00 PM","6:00 PM","7:00 PM","8:00 PM","9:00 PM","10:00 PM","11:00 PM"];

    //Handlers Is Sunday On Change
    const handleShowSundayChange = (e) => {
        const checked = e.target.checked;
        setShowSunday(checked);
        updateBusinessHoursTabData("is_sunday_on", checked); 
    };

    //Handlers Sunday Start Time Change
    const handleSundayStartTimeChange = (time) => {
        setSundayStartTime(time);
        updateBusinessHoursTabData("sunday_start_time", time); 
        setSundayStartTimeDropdownOpen(false);
    };

    //Handlers Sunday End Time Change
    const handleSundayEndTimeChange = (time) => {
        setSundayEndTime(time);
        updateBusinessHoursTabData("sunday_end_time", time); 
        setSundayEndTimeDropdownOpen(false);
    };

    //Handlers Is Monday On Change
    const handleShowMondayChange = (e) => {
        const checked = e.target.checked;
        setShowMonday(checked);
        updateBusinessHoursTabData("is_monday_on", checked); 
    };

    //Handlers Monday Start Time Change
    const handleMondayStartTimeChange = (time) => {
        setMondayStartTime(time);
        updateBusinessHoursTabData("monday_start_time", time); 
        setMondayStartTimeDropdownOpen(false);
    };

    //Handlers Monday End Time Change
    const handleMondayEndTimeChange = (time) => {
        setMondayEndTime(time);
        updateBusinessHoursTabData("monday_end_time", time); 
        setMondayEndTimeDropdownOpen(false);
    };

    //Handlers Is Tuesday On Change
    const handleShowTuesdayChange = (e) => {
        const checked = e.target.checked;
        setShowTuesday(checked);
        updateBusinessHoursTabData("is_tuesday_on", checked); 
    };

    //Handlers Tuesday Start Time Change
    const handleTuesdayStartTimeChange = (time) => {
        setTuesdayStartTime(time);
        updateBusinessHoursTabData("tuesday_start_time", time); 
        setTuesdayStartTimeDropdownOpen(false);
    };

    //Handlers Tuesday End Time Change
    const handleTuesdayEndTimeChange = (time) => {
        setTuesdayEndTime(time);
        updateBusinessHoursTabData("tuesday_end_time", time); 
        setTuesdayEndTimeDropdownOpen(false);
    };

    //Handlers Is Wednesday On Change
    const handleShowWednesdayChange = (e) => {
        const checked = e.target.checked;
        setShowWednesday(checked);
        updateBusinessHoursTabData("is_wednesday_on", checked); 
    };

    //Handlers Wednesday Start Time Change
    const handleWednesdayStartTimeChange = (time) => {
        setWednesdayStartTime(time);
        updateBusinessHoursTabData("wednesday_start_time", time); 
        setWednesdayStartTimeDropdownOpen(false);
    };

    //Handlers Wednesday End Time Change
    const handleWednesdayEndTimeChange = (time) => {
        setWednesdayEndTime(time);
        updateBusinessHoursTabData("wednesday_end_time", time); 
        setWednesdayEndTimeDropdownOpen(false);
    };


    //Handlers Is Thursday On Change
    const handleShowThursdayChange = (e) => {
        const checked = e.target.checked;
        setShowThursday(checked);
        updateBusinessHoursTabData("is_thursday_on", checked); 
    };

    //Handlers Thursday Start Time Change
    const handleThursdayStartTimeChange = (time) => {
        setThursdayStartTime(time);
        updateBusinessHoursTabData("thursday_start_time", time); 
        setThursdayStartTimeDropdownOpen(false);
    };

    //Handlers Thursday End Time Change
    const handleThursdayEndTimeChange = (time) => {
        setThursdayEndTime(time);
        updateBusinessHoursTabData("thursday_end_time", time); 
        setThursdayEndTimeDropdownOpen(false);
    };

    //Handlers Is Friday On Change
    const handleShowFridayChange = (e) => {
        const checked = e.target.checked;
        setShowFriday(checked);
        updateBusinessHoursTabData("is_friday_on", checked); 
    };

    //Handlers Friday Start Time Change
    const handleFridayStartTimeChange = (time) => {
        setFridayStartTime(time);
        updateBusinessHoursTabData("friday_start_time", time); 
        setFridayStartTimeDropdownOpen(false);
    };

    //Handlers Friday End Time Change
    const handleFridayEndTimeChange = (time) => {
        setFridayEndTime(time);
        updateBusinessHoursTabData("friday_end_time", time); 
        setFridayEndTimeDropdownOpen(false);
    };

    //Handlers Is Saturday On Change
    const handleShowSaturdayChange = (e) => {
        const checked = e.target.checked;
        setShowSaturday(checked);
        updateBusinessHoursTabData("is_saturday_on", checked); 
    };

    //Handlers Saturday Start Time Change
    const handleSaturdayStartTimeChange = (time) => {
        setSaturdayStartTime(time);
        updateBusinessHoursTabData("saturday_start_time", time); 
        setSundayStartTimeDropdownOpen(false);
    };

    //Handlers Saturday End Time Change
    const handleSaturdayEndTimeChange = (time) => {
        setSaturdayEndTime(time);
        updateBusinessHoursTabData("saturday_end_time", time); 
        setSaturdayEndTimeDropdownOpen(false);
    };

    // Handlers Business Name Change
    const handleBusinessNameChange = (event) => {
        const value = event.target.value;
        setBusinessName(value);
        updateBusinessHoursTabData("business_name", value);
    };

    // Handlers About Company Change
    const handleAboutCompanyChange = (event) => {
        const value = event.target.value;
        setAboutCompany(value);
        updateBusinessHoursTabData("about_company", value);
    };

    // Handlers Phone Number Change
    const handlePhoneNumberChange = (event) => {
        const value = event.target.value;
        setPhoneNumber(value);
        updateBusinessHoursTabData("phone_number", value);
    };

    // Handlers Email Change
    const handleEmailChange = (event) => {
        const value = event.target.value;
        setEmail(value);
        updateBusinessHoursTabData("email", value);
    };

    // Handlers Webiste Change
    const handleWebsiteChange = (event) => {
        const value = event.target.value;
        setWebsite(value);
        updateBusinessHoursTabData("website", value);
    };

    // Handlers Address Change
    const handleAddressChange = (event) => {
        const value = event.target.value;
        setAddress(value);
        updateBusinessHoursTabData("address", value);
    };

    //Handlers Is Labels On Change
    const handleShowLabelsChange = (e) => {
        const checked = e.target.checked;
        setShowLabels(checked);
        updateBusinessHoursTabData("is_show_labels_on", checked); 
    };

    //Handlers Is Icons On Change
    const handleShowIconsChange = (e) => {
        const checked = e.target.checked;
        setShowIcons(checked);
        updateBusinessHoursTabData("is_show_icons_on", checked); 
    };
    
    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Content</span>
                   
                    <div className="customize-elements-list">
                            <span className="text-sm p-2 m-1 pb-0">Business Hours</span>
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("sunday")}>Sunday 
                                    {showSunday ? (
                                        <>
                                            <em>{sundayStartTime} - {sundayEndTime}</em>
                                        </>
                                    ) : (
                                        <em>Closed</em>
                                    )}
                                 <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("monday")}>Monday 
                                {showMonday ? (
                                    <>
                                        <em>{mondayStartTime} - {mondayEndTime}</em>
                                    </>
                                ) : (
                                    <em>Closed</em>
                                )}
                                <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("tuesday")}>Tuesday
                                {showTuesday ? (
                                    <>
                                        <em>{tuesdayStartTime} - {tuesdayEndTime}</em>
                                    </>
                                ) : (
                                    <em>Closed</em>
                                )}
                                <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("wednesday")}>Wednesday 
                                {showWednesday ? (
                                    <>
                                        <em>{wednesdayStartTime} - {wednesdayEndTime}</em>
                                    </>
                                ) : (
                                    <em>Closed</em>
                                )}
                                <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("thursday")}>Thursday 
                                {showThursday ? (
                                    <>
                                        <em>{thursdayStartTime} - {thursdayEndTime}</em>
                                    </>
                                ) : (
                                    <em>Closed</em>
                                )}
                                <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("friday")}>Friday 
                                {showFriday ? (
                                    <>
                                        <em>{fridayStartTime} - {fridayEndTime}</em>
                                    </>
                                ) : (
                                    <em>Closed</em>
                                )}
                                <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("saturday")}>Saturday 
                                {showSaturday ? (
                                    <>
                                        <em>{saturdayStartTime} - {saturdayEndTime}</em>
                                    </>
                                ) : (
                                    <em>Closed</em>
                                )}
                                <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>

                    {/* <div className="layout-box-all">
                        <div className="card h-100">
                            <div className="name-tile-row">Additional Info</div>
                        </div>
                    </div> */}
                    <div className="customize-elements-list">
                          <span className="text-sm p-2 m-1 pb-0">Additional Info</span>
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("business_details")}>Business Details <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("contacts")}>Contacts <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "sunday" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Sunday</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Open</span>
                                <div className="form-group">
                                    <input id="open_is_show_sunday" className="chkbx-toggle" type="checkbox" checked={showSunday} onChange={handleShowSundayChange} />
                                    <label for="open_is_show_sunday"></label> 
                                </div>
                            </div>
                        </div>
                        {Number(businessHoursTabData.is_sunday_on) === 1 && (
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <div className="color-pikr-box-start" onClick={() => setSundayStartTimeDropdownOpen(!sundayStartTimeDropdownOpen)}>
                                        <em>{sundayStartTime}</em>
                                        {sundayStartTimeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {timeLists.map((time) => (
                                                    <li key={time} onClick={() => handleSundayStartTimeChange(time)}>
                                                        {time}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                    <span>--</span>
                                    <div className="color-pikr-box-end" onClick={() => setSundayEndTimeDropdownOpen(!sundayEndTimeDropdownOpen)}>
                                        <em>{sundayEndTime}</em>
                                        {sundayEndTimeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {timeLists.map((time) => (
                                                    <li key={time} onClick={() => handleSundayEndTimeChange(time)}>
                                                        {time}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}

            {activeSettingElementsTab === "monday" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Monday</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Open</span>
                                <div className="form-group">
                                    <input id="open_is_show_sunday" className="chkbx-toggle" type="checkbox" checked={showMonday} onChange={handleShowMondayChange} />
                                    <label for="open_is_show_sunday"></label> 
                                </div>
                            </div>
                        </div>
                        {Number(businessHoursTabData.is_monday_on) === 1 && (
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <div className="color-pikr-box-start" onClick={() => setMondayStartTimeDropdownOpen(!mondayStartTimeDropdownOpen)}>
                                        <em>{mondayStartTime}</em>
                                        {mondayStartTimeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {timeLists.map((time) => (
                                                    <li key={time} onClick={() => handleMondayStartTimeChange(time)}>
                                                        {time}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                    <span>--</span>
                                    <div className="color-pikr-box-end" onClick={() => setMondayEndTimeDropdownOpen(!mondayEndTimeDropdownOpen)}>
                                        <em>{mondayEndTime}</em>
                                        {mondayEndTimeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {timeLists.map((time) => (
                                                    <li key={time} onClick={() => handleMondayEndTimeChange(time)}>
                                                        {time}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}

            {activeSettingElementsTab === "tuesday" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Tuesday</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Open</span>
                                <div className="form-group">
                                    <input id="open_is_show_sunday" className="chkbx-toggle" type="checkbox" checked={showTuesday} onChange={handleShowTuesdayChange} />
                                    <label for="open_is_show_sunday"></label> 
                                </div>
                            </div>
                        </div>
                        {Number(businessHoursTabData.is_tuesday_on) === 1 && (
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <div className="color-pikr-box-start" onClick={() => setTuesdayStartTimeDropdownOpen(!tuesdayStartTimeDropdownOpen)}>
                                        <em>{tuesdayStartTime}</em>
                                        {tuesdayStartTimeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {timeLists.map((time) => (
                                                    <li key={time} onClick={() => handleTuesdayStartTimeChange(time)}>
                                                        {time}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                    <span>--</span>
                                    <div className="color-pikr-box-end" onClick={() => setTuesdayEndTimeDropdownOpen(!tuesdayEndTimeDropdownOpen)}>
                                        <em>{tuesdayEndTime}</em>
                                        {tuesdayEndTimeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {timeLists.map((time) => (
                                                    <li key={time} onClick={() => handleTuesdayEndTimeChange(time)}>
                                                        {time}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}

            {activeSettingElementsTab === "wednesday" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Wednesday</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Open</span>
                                <div className="form-group">
                                    <input id="open_is_show_sunday" className="chkbx-toggle" type="checkbox" checked={showWednesday} onChange={handleShowWednesdayChange} />
                                    <label for="open_is_show_sunday"></label> 
                                </div>
                            </div>
                        </div>
                        {Number(businessHoursTabData.is_wednesday_on) === 1 && (
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <div className="color-pikr-box-start" onClick={() => setWednesdayStartTimeDropdownOpen(!wednesdayStartTimeDropdownOpen)}>
                                        <em>{wednesdayStartTime}</em>
                                        {wednesdayStartTimeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {timeLists.map((time) => (
                                                    <li key={time} onClick={() => handleWednesdayStartTimeChange(time)}>
                                                        {time}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                    <span>--</span>
                                    <div className="color-pikr-box-end" onClick={() => setWednesdayEndTimeDropdownOpen(!wednesdayEndTimeDropdownOpen)}>
                                        <em>{wednesdayEndTime}</em>
                                        {wednesdayEndTimeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {timeLists.map((time) => (
                                                    <li key={time} onClick={() => handleWednesdayEndTimeChange(time)}>
                                                        {time}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}

            {activeSettingElementsTab === "thursday" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Thursday</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Open</span>
                                <div className="form-group">
                                    <input id="open_is_show_sunday" className="chkbx-toggle" type="checkbox" checked={showThursday} onChange={handleShowThursdayChange} />
                                    <label for="open_is_show_sunday"></label> 
                                </div>
                            </div>
                        </div>
                        {Number(businessHoursTabData.is_thursday_on) === 1 && (
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <div className="color-pikr-box-start" onClick={() => setThursdayStartTimeDropdownOpen(!thursdayStartTimeDropdownOpen)}>
                                        <em>{thursdayStartTime}</em>
                                        {thursdayStartTimeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {timeLists.map((time) => (
                                                    <li key={time} onClick={() => handleThursdayStartTimeChange(time)}>
                                                        {time}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                    <span>--</span>
                                    <div className="color-pikr-box-end" onClick={() => setThursdayEndTimeDropdownOpen(!thursdayEndTimeDropdownOpen)}>
                                        <em>{thursdayEndTime}</em>
                                        {thursdayEndTimeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {timeLists.map((time) => (
                                                    <li key={time} onClick={() => handleThursdayEndTimeChange(time)}>
                                                        {time}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}

            {activeSettingElementsTab === "friday" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Friday</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Open</span>
                                <div className="form-group">
                                    <input id="open_is_show_sunday" className="chkbx-toggle" type="checkbox" checked={showFriday} onChange={handleShowFridayChange} />
                                    <label for="open_is_show_sunday"></label> 
                                </div>
                            </div>
                        </div>
                        {Number(businessHoursTabData.is_friday_on) === 1 && (
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <div className="color-pikr-box-start" onClick={() => setFridayStartTimeDropdownOpen(!fridayStartTimeDropdownOpen)}>
                                        <em>{fridayStartTime}</em>
                                        {fridayStartTimeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {timeLists.map((time) => (
                                                    <li key={time} onClick={() => handleFridayStartTimeChange(time)}>
                                                        {time}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                    <span>--</span>
                                    <div className="color-pikr-box-end" onClick={() => setFridayEndTimeDropdownOpen(!fridayEndTimeDropdownOpen)}>
                                        <em>{fridayEndTime}</em>
                                        {fridayEndTimeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {timeLists.map((time) => (
                                                    <li key={time} onClick={() => handleFridayEndTimeChange(time)}>
                                                        {time}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}

            {activeSettingElementsTab === "saturday" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Saturday</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Open</span>
                                <div className="form-group">
                                    <input id="open_is_show_sunday" className="chkbx-toggle" type="checkbox" checked={showSaturday} onChange={handleShowSaturdayChange} />
                                    <label for="open_is_show_sunday"></label> 
                                </div>
                            </div>
                        </div>
                        {Number(businessHoursTabData.is_saturday_on) === 1 && (
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <div className="color-pikr-box-start" onClick={() => setSaturdayStartTimeDropdownOpen(!saturdayStartTimeDropdownOpen)}>
                                        <em>{saturdayStartTime}</em>
                                        {saturdayStartTimeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {timeLists.map((time) => (
                                                    <li key={time} onClick={() => handleSaturdayStartTimeChange(time)}>
                                                        {time}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                    <span>--</span>
                                    <div className="color-pikr-box-end" onClick={() => setSaturdayEndTimeDropdownOpen(!saturdayEndTimeDropdownOpen)}>
                                        <em>{saturdayEndTime}</em>
                                        {saturdayEndTimeDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {timeLists.map((time) => (
                                                    <li key={time} onClick={() => handleSaturdayEndTimeChange(time)}>
                                                        {time}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}

            {activeSettingElementsTab === "business_details" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Business Details</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <div className="name-tile-row">Business Name</div>
                                <div className="box-header-row bubble-text px-0 pt-0">
                                    <input type="text" value={businessName} onChange={handleBusinessNameChange} />
                                </div>
                                <div className="name-tile-row">About Company</div>
                                <div className="box-header-row bubble-text px-0 pt-0 border-0">
                                    <div className="box-header-row welcome-message p-0 border-0">
                                        <textarea value={aboutCompany} onChange={handleAboutCompanyChange} defaultValue=""></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "contacts" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Contacts</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <div className="name-tile-row">Phone</div>
                                <div className="box-header-row bubble-text">
                                    <input type="text" value={phoneNumber} onChange={handlePhoneNumberChange} />
                                </div>
                                <div className="name-tile-row">Email</div>
                                <div className="box-header-row bubble-text">
                                    <input type="email" value={email} onChange={handleEmailChange} />
                                </div>
                                <div className="name-tile-row">Website</div>
                                <div className="box-header-row bubble-text">
                                    <input type="text" value={website} onChange={handleWebsiteChange} />
                                </div>
                                <div className="name-tile-row">Address</div>
                                <div className="box-header-row bubble-text">
                                    <input type="text" value={address} onChange={handleAddressChange} />
                                </div>
                            </div>
                        </div>

                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Show Labels</span>
                                <div className="form-group">
                                    <input id="open_is_show_labels" className="chkbx-toggle" type="checkbox" checked={showLabels} onChange={handleShowLabelsChange} />
                                    <label for="open_is_show_labels"></label> 
                                </div>
                            </div>
                            <div className="box-header-row"><span>Show Icons</span>
                                <div className="form-group">
                                    <input id="open_is_show_icons" className="chkbx-toggle" type="checkbox" checked={showIcons} onChange={handleShowIconsChange} />
                                    <label for="open_is_show_icons"></label> 
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default ContentTab;